var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a,.d{fill-rule:evenodd;}.b,.c,.d{stroke:#e6007e;}.c,.d{fill:#e6007e;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 20,
    height: 16,
    rx: 1,
    transform: "translate(18) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 4,
    height: 3,
    rx: 1,
    transform: "translate(8.5 12.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1,
    height: 1,
    rx: 0.5,
    transform: "translate(14.5 15.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1,
    height: 1,
    rx: 0.5,
    transform: "translate(14.5 13.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1,
    height: 1,
    rx: 0.5,
    transform: "translate(14.5 10.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1,
    height: 1,
    rx: 0.5,
    transform: "translate(14.5 8.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 1,
    height: 1,
    rx: 0.5,
    transform: "translate(14.5 5.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1,0H2V2.5H18V0h1a1,1,0,0,1,1,1V3a1,1,0,0,1-1,1H1A1,1,0,0,1,0,3V1A1,1,0,0,1,1,0Z",
    transform: "translate(20 4) rotate(180)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtm);
export default __webpack_public_path__ + "static/media/atm.d96ffa83b4964998ad0bb249b6509fba.svg";
export { ForwardRef as ReactComponent };